import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DAL_OPTIONS, DalOptions } from '../dal.module';
import { ReadSpeakerConfigInterface } from './read-speaker-config.interface';
import { ReadSpeakerConfigServiceInterface } from './read-speaker-config.service.interface';

@Injectable({
  providedIn: 'root',
})
export class ReadSpeakerConfigService implements ReadSpeakerConfigServiceInterface {
  private http = inject(HttpClient);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private apiV1BaseUrl = this.dalOptions.apiBaseUrl + '/api/ReadSpeakerConfigs';

  getReadSpeakerConfigs$(): Observable<ReadSpeakerConfigInterface[]> {
    const url = `${this.apiV1BaseUrl}`;
    return this.http.get<ReadSpeakerConfigInterface[]>(url, { withCredentials: true });
  }

  getReadSpeakerConfigById$(readSpeakerConfigId: number): Observable<ReadSpeakerConfigInterface> {
    const url = `${this.apiV1BaseUrl}/${readSpeakerConfigId}`;
    return this.http.get<ReadSpeakerConfigInterface>(url, { withCredentials: true });
  }

  createReadSpeakerConfig$(
    readSpeakerConfig: Partial<ReadSpeakerConfigInterface>
  ): Observable<ReadSpeakerConfigInterface> {
    const url = `${this.apiV1BaseUrl}`;
    return this.http.post<ReadSpeakerConfigInterface>(url, readSpeakerConfig, { withCredentials: true });
  }

  patchReadSpeakerConfig$(
    readSpeakerConfigId: number,
    changes?: Partial<ReadSpeakerConfigInterface>
  ): Observable<ReadSpeakerConfigInterface> {
    const url = `${this.apiV1BaseUrl}/${readSpeakerConfigId}`;
    return this.http.patch<ReadSpeakerConfigInterface>(url, changes, { withCredentials: true });
  }

  deleteReadSpeakerConfig$(readSpeakerConfigId: number): Observable<number> {
    const url = `${this.apiV1BaseUrl}/${readSpeakerConfigId}`;
    return this.http.delete<number>(url, { withCredentials: true });
  }
}
